import { useState, useRef } from "react";
import arrow from "../components/img/gallery/artwork/right-arrow.png";
import {
  galleryItems,
  artworkItems,
  photography,
} from "../data/galleryData.js";
import "../styles.css";
import AnimatedBackground from "../components/AnimatedGallery.js";

export function GalleryTab() {
  const [selectedImage, setSelectedImage] = useState(null);

  // Define the reference for the scrollable container
  const scrollRef = useRef(null);

  // Renamed to handleScroll to fix ESLint 'no-restricted-globals'
  const handleScroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      // Moves by the full width of the container to show exactly one image
      const scrollAmount = current.offsetWidth;
      current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // Change this to include "Photography" category
  const archive = galleryItems.filter(
    (item) =>
      item.category === "Archive" ||
      item.category === "Photography" ||
      !item.category,
  );

  return (
    <>
      <AnimatedBackground />
      <div className="page-section gallery-container">
        {/* CAROUSEL 1: Digital Artworks */}
        <section className="artwork">
          <h2 className="artwork-title">{artworkItems[0].title}</h2>
          <div className="hero-artwork">
            <img
              className="artwork_image"
              onContextMenu={(e) => e.preventDefault()} // Disables right-click
              onDragStart={(e) => e.preventDefault()}
              src={artworkItems[0].image}
            />
            <div className="artwork_text">
              <h1 className="artwork_title_small">{artworkItems[0].title}</h1>
              <p className="artwork_description">
                {artworkItems[0].description}
              </p>
            </div>
          </div>
        </section>

        {/* CAROUSEL 2: Photography */}
        <section className="carousel-section">
          <h2 className="artwork-title">Veiled Realities</h2>

          <div className="carousel-viewport-wrapper">
            {/* Navigation Buttons now inside the wrapper */}
            <button
              className="nav-btn prev-overlay"
              onClick={() => handleScroll("left")}
            >
              <img
                src={arrow}
                alt="Left Arrow"
                width={20}
                style={{ transform: "rotate(180deg)" }}
              />
            </button>
            <button
              className="nav-btn next-overlay"
              onClick={() => handleScroll("right")}
            >
              <img src={arrow} alt="Left Arrow" width={20} />
            </button>

            <div className="carousel-container" ref={scrollRef}>
              <div className="hero-carousel">
                {photography.map((item) => (
                  <div
                    key={item.id}
                    className={`carousel-card single-view ${item.type}`}
                    onClick={() => setSelectedImage(item)}
                  >
                    <img
                      src={item.preview || item.image} // Use the lighter version for the moving part
                      alt={item.title}
                      loading="lazy"
                      onContextMenu={(e) => e.preventDefault()}
                      onDragStart={(e) => e.preventDefault()}
                    />
                    <div className="image-shield"></div>
                    <div className="carousel-caption">
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* COLLAGE: The rest of the photos */}
        <section className="collage-section">
          <h2 className="artwork-title">Photo Archive</h2>
          <div className="collage-grid">
            {archive.map((item, index) => (
              <div
                key={item.id}
                className="collage-item"
                onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  loading="lazy"
                  onContextMenu={(e) => e.preventDefault()}
                  onDragStart={(e) => e.preventDefault()}
                />
                <div className="gallery-overlay">
                  <span>{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Lightbox Modal (Keep your existing code) */}
        {selectedImage && (
          <div className="lightbox" onClick={() => setSelectedImage(null)}>
            <div className="lightbox-content">
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="lightbox-image"
                onClick={(e) => e.stopPropagation()}
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
              <div className="lightbox-info">
                <h3 className="lightbox-title">{selectedImage.title}</h3>
                <p className="gallery-category">{selectedImage.category}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
